import { gql } from '@apollo/client'
import { buildGraphqlQuery } from '@ztechapps/common.utils'

export const mailgunEventFragment = gql`
  fragment mailgunEventFragment on MailgunEvent {
    _id
    subject
    bodyHtml
    bodyPlain
    event
    timeStamp
    metadata
    recipient
  }
`
export const mailgunEventQuery = buildGraphqlQuery('MailgunEvent', mailgunEventFragment)
